export default {
  dark: 'Темний',
  light: 'Світло',
};
